"use strict";

/*
 * This file contains some shared functions. They are used by other modules, but
 * are defined here so that tests can import this library and test them.
 */
var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var HttpError_1 = require("./HttpError");
var settings_1 = require("./settings");
var debug = require("debug"); // $lab:coverage:off$
// @ts-ignore

var _ref = typeof FHIRCLIENT_PURE !== "undefined" ? window : require("cross-fetch"),
  fetch = _ref.fetch; // $lab:coverage:on$

var _debug = debug("FHIR");
exports.debug = _debug;
/**
 * The cache for the `getAndCache` function
 */

var cache = {};
/**
 * A namespace with functions for converting between different measurement units
 */

exports.units = {
  cm: function cm(_ref2) {
    var code = _ref2.code,
      value = _ref2.value;
    ensureNumerical({
      code: code,
      value: value
    });
    if (code == "cm") return value;
    if (code == "m") return value * 100;
    if (code == "in") return value * 2.54;
    if (code == "[in_us]") return value * 2.54;
    if (code == "[in_i]") return value * 2.54;
    if (code == "ft") return value * 30.48;
    if (code == "[ft_us]") return value * 30.48;
    throw new Error("Unrecognized length unit: " + code);
  },
  kg: function kg(_ref3) {
    var code = _ref3.code,
      value = _ref3.value;
    ensureNumerical({
      code: code,
      value: value
    });
    if (code == "kg") return value;
    if (code == "g") return value / 1000;
    if (code.match(/lb/)) return value / 2.20462;
    if (code.match(/oz/)) return value / 35.274;
    throw new Error("Unrecognized weight unit: " + code);
  },
  any: function any(pq) {
    ensureNumerical(pq);
    return pq.value;
  }
};
/**
 * Assertion function to guard arguments for `units` functions
 */

function ensureNumerical(_ref4) {
  var value = _ref4.value,
    code = _ref4.code;
  if (typeof value !== "number") {
    throw new Error("Found a non-numerical unit: " + value + " " + code);
  }
}
/**
 * Used in fetch Promise chains to reject if the "ok" property is not true
 */
function checkResponse(_x) {
  return _checkResponse.apply(this, arguments);
}
function _checkResponse() {
  _checkResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resp) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (resp.ok) {
            _context.next = 4;
            break;
          }
          _context.next = 3;
          return humanizeError(resp);
        case 3:
          throw _context.sent;
        case 4:
          return _context.abrupt("return", resp);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _checkResponse.apply(this, arguments);
}
exports.checkResponse = checkResponse;
/**
 * Used in fetch Promise chains to return the JSON version of the response.
 * Note that `resp.json()` will throw on empty body so we use resp.text()
 * instead.
 */

function responseToJSON(resp) {
  return resp.text().then(function (text) {
    return text.length ? JSON.parse(text) : "";
  });
}
exports.responseToJSON = responseToJSON;
/**
 * This is our built-in request function. It does a few things by default
 * (unless told otherwise):
 * - Makes CORS requests
 * - Sets accept header to "application/json"
 * - Handles errors
 * - If the response is json return the json object
 * - If the response is text return the result text
 * - Otherwise return the response object on which we call stuff like `.blob()`
 */

function request(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return fetch(url, Object.assign(Object.assign({
    mode: "cors"
  }, options), {
    headers: Object.assign({
      accept: "application/json"
    }, options.headers)
  })).then(checkResponse).then(function (res) {
    var type = res.headers.get("Content-Type") + "";
    if (type.match(/\bjson\b/i)) {
      return responseToJSON(res);
    }
    if (type.match(/^text\//i)) {
      return res.text();
    }
    return res;
  });
}
exports.request = request;
/**
 * Makes a request using `fetch` and stores the result in internal memory cache.
 * The cache is cleared when the page is unloaded.
 * @param url The URL to request
 * @param requestOptions Request options
 * @param force If true, reload from source and update the cache, even if it has
 * already been cached.
 */

function getAndCache(url, requestOptions) {
  var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : process.env.NODE_ENV === "test";
  if (force || !cache[url]) {
    cache[url] = request(url, requestOptions);
    return cache[url];
  }
  return Promise.resolve(cache[url]);
}
exports.getAndCache = getAndCache;
/**
 * Fetches the conformance statement from the given base URL.
 * Note that the result is cached in memory (until the page is reloaded in the
 * browser) because it might have to be re-used by the client
 * @param baseUrl The base URL of the FHIR server
 * @param [requestOptions] Any options passed to the fetch call
 */

function fetchConformanceStatement() {
  var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var requestOptions = arguments.length > 1 ? arguments[1] : undefined;
  var url = String(baseUrl).replace(/\/*$/, "/") + "metadata";
  return getAndCache(url, requestOptions).catch(function (ex) {
    throw new Error("Failed to fetch the conformance statement from \"".concat(url, "\". ").concat(ex));
  });
}
exports.fetchConformanceStatement = fetchConformanceStatement;
/**
 * Given a response object, generates and throws detailed HttpError.
 * @param resp The `Response` object of a failed `fetch` request
 */
function humanizeError(_x2) {
  return _humanizeError.apply(this, arguments);
}
function _humanizeError() {
  _humanizeError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resp) {
    var msg, type, json, text;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          msg = "".concat(resp.status, " ").concat(resp.statusText, "\nURL: ").concat(resp.url);
          _context2.prev = 1;
          type = resp.headers.get("Content-Type") || "text/plain";
          if (!type.match(/\bjson\b/i)) {
            _context2.next = 8;
            break;
          }
          _context2.next = 6;
          return resp.json();
        case 6:
          json = _context2.sent;
          if (json.error) {
            msg += "\n" + json.error;
            if (json.error_description) {
              msg += ": " + json.error_description;
            }
          } else {
            msg += "\n\n" + JSON.stringify(json, null, 4);
          }
        case 8:
          if (!type.match(/^text\//i)) {
            _context2.next = 13;
            break;
          }
          _context2.next = 11;
          return resp.text();
        case 11:
          text = _context2.sent;
          if (text) {
            msg += "\n\n" + text;
          }
        case 13:
          _context2.next = 17;
          break;
        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](1);
        case 17:
          throw new HttpError_1.default(msg, resp.status, resp.statusText);
        case 18:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 15]]);
  }));
  return _humanizeError.apply(this, arguments);
}
exports.humanizeError = humanizeError;
/**
 * Walks through an object (or array) and returns the value found at the
 * provided path. This function is very simple so it intentionally does not
 * support any argument polymorphism, meaning that the path can only be a
 * dot-separated string. If the path is invalid returns undefined.
 * @param obj The object (or Array) to walk through
 * @param path The path (eg. "a.b.4.c")
 * @returns {*} Whatever is found in the path or undefined
 */

function getPath(obj) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  path = path.trim();
  if (!path) {
    return obj;
  }
  return path.split(".").reduce(function (out, key) {
    return out ? out[key] : undefined;
  }, obj);
}
exports.getPath = getPath;
/**
 * Like getPath, but if the node is found, its value is set to @value
 * @param obj   The object (or Array) to walk through
 * @param path  The path (eg. "a.b.4.c")
 * @param value The value to set
 * @returns The modified object
 */

function setPath(obj, path, value) {
  path.trim().split(".").reduce(function (out, key, idx, arr) {
    if (out && idx === arr.length - 1) {
      out[key] = value;
    } else {
      return out ? out[key] : undefined;
    }
  }, obj);
  return obj;
}
exports.setPath = setPath;
/**
 * If the argument is an array returns it as is. Otherwise puts it in an array
 * (`[arg]`) and returns the result
 * @param arg The element to test and possibly convert to array
 * @category Utility
 */

function makeArray(arg) {
  if (Array.isArray(arg)) {
    return arg;
  }
  return [arg];
}
exports.makeArray = makeArray;
/**
 * Given a path, converts it to absolute url based on the `baseUrl`. If baseUrl
 * is not provided, the result would be a rooted path (one that starts with `/`).
 * @param path The path to convert
 * @param baseUrl The base URL
 */

function absolute(path, baseUrl) {
  if (path.match(/^http/)) return path;
  if (path.match(/^urn/)) return path;
  return String(baseUrl || "").replace(/\/+$/, "") + "/" + path.replace(/^\/+/, "");
}
exports.absolute = absolute;
/**
 * Generates random strings. By default this returns random 8 characters long
 * alphanumeric strings.
 * @param strLength The length of the output string. Defaults to 8.
 * @param charSet A string containing all the possible characters.
 *     Defaults to all the upper and lower-case letters plus digits.
 * @category Utility
 */

function randomString() {
  var strLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
  var charSet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var result = [];
  var len = charSet.length;
  while (strLength--) {
    result.push(charSet.charAt(Math.floor(Math.random() * len)));
  }
  return result.join("");
}
exports.randomString = randomString;
/**
 * Decodes a JWT token and returns it's body.
 * @param token The token to read
 * @param env An `Adapter` or any other object that has an `atob` method
 * @category Utility
 */

function jwtDecode(token, env) {
  var payload = token.split(".")[1];
  return JSON.parse(env.atob(payload));
}
exports.jwtDecode = jwtDecode;
/**
 * Groups the observations by code. Returns a map that will look like:
 * ```js
 * const map = client.byCodes(observations, "code");
 * // map = {
 * //     "55284-4": [ observation1, observation2 ],
 * //     "6082-2": [ observation3 ]
 * // }
 * ```
 * @param observations Array of observations
 * @param property The name of a CodeableConcept property to group by
 */

function byCode(observations, property) {
  var ret = {};
  function handleCodeableConcept(concept, observation) {
    if (concept && Array.isArray(concept.coding)) {
      concept.coding.forEach(function (_ref5) {
        var code = _ref5.code;
        if (code) {
          ret[code] = ret[code] || [];
          ret[code].push(observation);
        }
      });
    }
  }
  makeArray(observations).forEach(function (o) {
    if (o.resourceType === "Observation" && o[property]) {
      if (Array.isArray(o[property])) {
        o[property].forEach(function (concept) {
          return handleCodeableConcept(concept, o);
        });
      } else {
        handleCodeableConcept(o[property], o);
      }
    }
  });
  return ret;
}
exports.byCode = byCode;
/**
 * First groups the observations by code using `byCode`. Then returns a function
 * that accepts codes as arguments and will return a flat array of observations
 * having that codes. Example:
 * ```js
 * const filter = client.byCodes(observations, "category");
 * filter("laboratory") // => [ observation1, observation2 ]
 * filter("vital-signs") // => [ observation3 ]
 * filter("laboratory", "vital-signs") // => [ observation1, observation2, observation3 ]
 * ```
 * @param observations Array of observations
 * @param property The name of a CodeableConcept property to group by
 */

function byCodes(observations, property) {
  var bank = byCode(observations, property);
  return function () {
    for (var _len = arguments.length, codes = new Array(_len), _key = 0; _key < _len; _key++) {
      codes[_key] = arguments[_key];
    }
    return codes.filter(function (code) {
      return code + "" in bank;
    }).reduce(function (prev, code) {
      return prev.concat(bank[code + ""]);
    }, []);
  };
}
exports.byCodes = byCodes;
/**
 * Given a conformance statement and a resource type, returns the name of the
 * URL parameter that can be used to scope the resource type by patient ID.
 */

function getPatientParam(conformance, resourceType) {
  // Find what resources are supported by this server
  var resources = getPath(conformance, "rest.0.resource") || []; // Check if this resource is supported

  var meta = resources.find(function (r) {
    return r.type === resourceType;
  });
  if (!meta) {
    throw new Error("Resource \"".concat(resourceType, "\" is not supported by this FHIR server"));
  } // Check if any search parameters are available for this resource

  if (!Array.isArray(meta.searchParam)) {
    throw new Error("No search parameters supported for \"".concat(resourceType, "\" on this FHIR server"));
  } // This is a rare case but could happen in generic workflows

  if (resourceType == "Patient" && meta.searchParam.find(function (x) {
    return x.name == "_id";
  })) {
    return "_id";
  } // Now find the first possible parameter name

  var out = settings_1.patientParams.find(function (p) {
    return meta.searchParam.find(function (x) {
      return x.name == p;
    });
  }); // If there is no match

  if (!out) {
    throw new Error("I don't know what param to use for " + resourceType);
  }
  return out;
}
exports.getPatientParam = getPatientParam;
/**
 * Resolves a reference to target window. It may also open new window or tab if
 * the `target = "popup"` or `target = "_blank"`.
 * @param target
 * @param width Only used when `target = "popup"`
 * @param height Only used when `target = "popup"`
 */
function getTargetWindow(_x3) {
  return _getTargetWindow.apply(this, arguments);
}
function _getTargetWindow() {
  _getTargetWindow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(target) {
    var width,
      height,
      error,
      targetWindow,
      _error,
      _targetWindow,
      winOrFrame,
      _args3 = arguments;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          width = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 800;
          height = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : 720;
          if (!(typeof target == "function")) {
            _context3.next = 6;
            break;
          }
          _context3.next = 5;
          return target();
        case 5:
          target = _context3.sent;
        case 6:
          if (!(target && typeof target == "object")) {
            _context3.next = 8;
            break;
          }
          return _context3.abrupt("return", target);
        case 8:
          if (!(typeof target != "string")) {
            _context3.next = 11;
            break;
          }
          _debug("Invalid target type '%s'. Failing back to '_self'.", typeof target);
          return _context3.abrupt("return", self);
        case 11:
          if (!(target == "_self")) {
            _context3.next = 13;
            break;
          }
          return _context3.abrupt("return", self);
        case 13:
          if (!(target == "_parent")) {
            _context3.next = 15;
            break;
          }
          return _context3.abrupt("return", parent);
        case 15:
          if (!(target == "_top")) {
            _context3.next = 17;
            break;
          }
          return _context3.abrupt("return", top);
        case 17:
          if (!(target == "_blank")) {
            _context3.next = 35;
            break;
          }
          targetWindow = null;
          ;
          _context3.prev = 20;
          targetWindow = window.open("", "SMARTAuthPopup");
          if (targetWindow) {
            _context3.next = 24;
            break;
          }
          throw new Error("Perhaps window.open was blocked");
        case 24:
          _context3.next = 29;
          break;
        case 26:
          _context3.prev = 26;
          _context3.t0 = _context3["catch"](20);
          error = _context3.t0;
        case 29:
          if (targetWindow) {
            _context3.next = 34;
            break;
          }
          _debug("Cannot open window. Failing back to '_self'. %s", error);
          return _context3.abrupt("return", self);
        case 34:
          return _context3.abrupt("return", targetWindow);
        case 35:
          if (!(target == "popup")) {
            _context3.next = 52;
            break;
          }
          _targetWindow = null; // if (!targetWindow || targetWindow.closed) {
          _context3.prev = 37;
          _targetWindow = window.open("", "SMARTAuthPopup", ["height=" + height, "width=" + width, "menubar=0", "resizable=1", "status=0", "top=" + (screen.height - height) / 2, "left=" + (screen.width - width) / 2].join(","));
          if (_targetWindow) {
            _context3.next = 41;
            break;
          }
          throw new Error("Perhaps the popup window was blocked");
        case 41:
          _context3.next = 46;
          break;
        case 43:
          _context3.prev = 43;
          _context3.t1 = _context3["catch"](37);
          _error = _context3.t1;
        case 46:
          if (_targetWindow) {
            _context3.next = 51;
            break;
          }
          _debug("Cannot open window. Failing back to '_self'. %s", _error);
          return _context3.abrupt("return", self);
        case 51:
          return _context3.abrupt("return", _targetWindow);
        case 52:
          // Frame or window by name
          winOrFrame = frames[target];
          if (!winOrFrame) {
            _context3.next = 55;
            break;
          }
          return _context3.abrupt("return", winOrFrame);
        case 55:
          _debug("Unknown target '%s'. Failing back to '_self'.", target);
          return _context3.abrupt("return", self);
        case 57:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[20, 26], [37, 43]]);
  }));
  return _getTargetWindow.apply(this, arguments);
}
exports.getTargetWindow = getTargetWindow;